import { type ClassValue, clsx } from 'clsx'
import path from 'path-browserify'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function resolveRoutePath(basePath?: string, routePath?: string) {
  return basePath ? path.resolve(basePath, routePath ?? '') : routePath ?? ''
}
export function debounce<T extends (...args: any[]) => any>(func: T, wait = 500) {
  // 使用 ref 来存储定时器
  const timeout = ref<ReturnType<typeof setTimeout> | null>(null)

  return function(this: ThisParameterType<T>, ...args: Parameters<T>) {
    // 清除之前的定时器
    if (timeout.value !== null) {
      clearTimeout(timeout.value)
    }

    // 设置新的定时器
    timeout.value = setTimeout(() => {
      func.apply(this, args)
      timeout.value = null
    }, wait)
  }
}
